const reasons = [
  {
    icon: 'ri-speed-up-line',
    title: 'Рынок меняется быстрее',
    desc: 'Новые технологии, продукты и бизнес-модели появляются ежегодно. Компании, которые не обучают сотрудников, теряют конкурентоспособность в течение 2-3 лет. Обучение персонала становится не опцией, а условием выживания.'
  },
  {
    icon: 'ri-user-unfollow-line',
    title: 'Сотрудники увольняются чаще',
    desc: 'По данным исследований, 94% сотрудников остались бы в компании дольше, если бы она инвестировала в их развитие. Текучка персонала обходится бизнесу в 50-200% годовой зарплаты сотрудника. Система обучения — мощный инструмент удержания.'
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Технологии обновляются постоянно',
    desc: 'Цифровизация, автоматизация и ИИ меняют каждую профессию. То, что работало год назад, сегодня устарело. Регулярное обучение сотрудников — единственный способ поддерживать актуальность компетенций команды.'
  },
  {
    icon: 'ri-star-line',
    title: 'Клиенты становятся требовательнее',
    desc: 'Уровень сервиса становится ключевым конкурентным преимуществом. Клиенты ожидают персонализированного подхода и высокого качества. Обученный персонал способен соответствовать этим ожиданиям и создавать выдающийся клиентский опыт.'
  },
  {
    icon: 'ri-time-line',
    title: 'Знания быстро устаревают',
    desc: 'Период полураспада профессиональных знаний сократился до 2-3 лет. Без непрерывного обучения персонала компания работает на устаревших подходах, теряя эффективность и долю рынка.'
  },
  {
    icon: 'ri-global-line',
    title: 'Глобальная конкуренция растёт',
    desc: 'Границы рынков стираются. Белорусские компании конкурируют не только между собой, но и с международными игроками. Развитие персонала — это инвестиция в конкурентоспособность на глобальном уровне.'
  }
];

const withoutTraining = [
  { text: 'Ошибки сотрудников', icon: 'ri-close-circle-line' },
  { text: 'Потери клиентов', icon: 'ri-user-unfollow-line' },
  { text: 'Текучесть кадров', icon: 'ri-arrow-go-back-line' },
  { text: 'Снижение прибыли', icon: 'ri-arrow-down-line' },
];

const withTraining = [
  { text: 'Рост компетенций', icon: 'ri-bar-chart-box-line' },
  { text: 'Рост качества', icon: 'ri-star-fill' },
  { text: 'Рост продаж', icon: 'ri-funds-line' },
  { text: 'Рост прибыли', icon: 'ri-arrow-up-line' },
];

export default function WhyTrainingStrategic() {
  return (
    <section id="why-strategic" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему обучение персонала стало стратегической задачей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Бизнес-среда изменилась. Компании, которые не инвестируют в развитие сотрудников, проигрывают конкурентам по всем фронтам. Вот шесть причин, почему обучение персонала — это не HR-функция, а стратегический приоритет.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {reasons.map((r, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-teal-200 transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <i className={`${r.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{r.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* Infographic: Without vs With Training */}
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-10">Два пути развития компании</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100">
              <h4 className="text-xl font-bold text-red-700 mb-6 text-center">Без обучения</h4>
              <div className="space-y-4">
                {withoutTraining.map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-red-600`}></i>
                    </div>
                    <span className="text-gray-700 font-medium">{item.text}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6 text-center">
                <i className="ri-arrow-down-line text-2xl text-red-400"></i>
              </div>
              <div className="text-center text-red-600 font-bold mt-2">Стагнация и потеря рынка</div>
            </div>

            <div className="bg-teal-50 rounded-2xl p-8 border border-teal-100">
              <h4 className="text-xl font-bold text-teal-700 mb-6 text-center">С обучением</h4>
              <div className="space-y-4">
                {withTraining.map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-teal-600`}></i>
                    </div>
                    <span className="text-gray-700 font-medium">{item.text}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6 text-center">
                <i className="ri-arrow-up-line text-2xl text-teal-400"></i>
              </div>
              <div className="text-center text-teal-600 font-bold mt-2">Устойчивый рост бизнеса</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}